import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { KeyValueString } from "../../../../../Models/KeyValueString";
import { TranslationService } from "../../Services/translation.service";
import { MatCard, MatCardTitle } from '@angular/material/card';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'aw-title-edit-form',
    templateUrl: './title-edit-form.component.html',
    styleUrls: ['../matrix-form.less', './title-edit-form.component.less'],
    imports: [MatCard, MatCardTitle, FormsModule, ReactiveFormsModule, MatButton]
})
export class TitleEditFormComponent implements OnInit {
  @Input() title: KeyValueString;
  @Output() saved: EventEmitter<string> = new EventEmitter<string>();
  @Output() cancelled: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('firstInput', { static: true }) firstInput: ElementRef;
  
  titleForm: UntypedFormGroup;
  
  constructor(private fb: UntypedFormBuilder, private translationService: TranslationService) { }

  ngOnInit() {
    this.titleForm = this.fb.group({
      title: ['', Validators.required],
    });
    this.translationService.getTranslation('sevmatrix:' + this.title.key, 'Text')
        .subscribe(translation => {
          this.titleForm.get('title').patchValue(translation);
          this.firstInput.nativeElement.focus();
      });
  }
  
  saveTitle() {
    if(this.titleForm.valid) {
      this.saved.emit(this.titleForm.get('title').value);
    } else {
      return false;
    }
  }
  
  cancel() {
    this.cancelled.emit('user cancelled');
  }
}
